import { render, staticRenderFns } from "./Establishment.vue?vue&type=template&id=6a29089d"
import script from "./Establishment.vue?vue&type=script&lang=js"
export * from "./Establishment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a29089d')) {
      api.createRecord('6a29089d', component.options)
    } else {
      api.reload('6a29089d', component.options)
    }
    module.hot.accept("./Establishment.vue?vue&type=template&id=6a29089d", function () {
      api.rerender('6a29089d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/Establishment.vue"
export default component.exports